import * as React from 'react'
import { formatDistanceToNow } from '../lib/time/utils'

export const useTimeDiff = (
  date: Date,
  options: { refreshIntervalMs?: number; short?: boolean } = {
    refreshIntervalMs: 3000,
    short: true,
  }
) => {
  const { refreshIntervalMs, short } = options

  const [timeDiff, setTimeDiff] = React.useState(
    formatDistanceToNow(new Date(date), short ?? true)
  )

  React.useEffect(() => {
    const interval = setInterval(() => {
      setTimeDiff(formatDistanceToNow(new Date(date), short ?? true))
    }, refreshIntervalMs ?? 3000)

    return () => clearInterval(interval)
  }, [date, refreshIntervalMs, short])

  return timeDiff
}
